export default __webpack_public_path__ + "static/cross_white-0642b9bf3afb14dca78f1c5258220217.png";